import React from "react"
import { Modal } from "@mui/material"
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined"
import { Box, Button, Typography } from "src/UILibrary"

interface Props {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  confirmText: string
  cancelText: string
  onConfirm: () => void
  onCancel: () => void
}

export default function AppModal({
  isOpen,
  onClose,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal open={isOpen} disableAutoFocus={true}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 680,
          maxHeight: "95vh",
          height: "260px",
          overflowY: "auto",
          bgcolor: "#FFF",
          boxShadow: 24,
          borderRadius: "2px",
          p: "40px",
        }}
      >
        <Box
          width="sm"
          display="flex"
          flexDirection="column"
          sx={{ borderRadius: "10px", bgcolor: "white", borderColor: "white", p: "0px" }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <DisabledByDefaultOutlinedIcon
              sx={{ color: "#00C298", cursor: "pointer", fontSize: "26px" }}
              onClick={() => onClose()}
            />
          </Box>
          <Typography.CardHead
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              paddingBottom: "10px",
              borderBottom: "1px solid #F3F3F3",
            }}
          >
            {title}
          </Typography.CardHead>
          <Box sx={{ py: "10px", display: "flex", alignItems: "center", height: "120px" }}>
            <Typography.CardHead
              sx={{
                color: "#333333",
                fontSize: "14px",
                fontWeight: "400",
                letterSpacing: "0",
              }}
            >
              {description}
            </Typography.CardHead>
          </Box>

          <Box display="block" textAlign="right">
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Zen Kaku Gothic New !important",
                mt: "10px",
                mx: "0.5rem",
                width: "155px",
                height: "44px",
                fontSize: "15px",
                fontWeight: 700,
                borderRadius: "4px",
                borderColor: "#00C298",
                color: "#00C298",
              }}
              onClick={() => onCancel()}
            >
              {cancelText}
            </Button>
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Zen Kaku Gothic New !important",
                mt: "10px",
                mx: "0.5rem",
                width: "155px",
                height: "44px",
                fontSize: "15px",
                fontWeight: 700,
                borderRadius: "4px",
                backgroundColor: "#00C298",
                color: "white",
                "&:hover": {
                  color: "#00C298",
                },
              }}
              onClick={() => onConfirm()}
            >
              {confirmText}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
